import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatCheckboxChange, MatDialog } from '@angular/material';
import { AuthService } from 'app/core/authentication/services';
import { UserInterface } from 'app/core/user/models';
import { InstalledStateEnum } from 'app/equipment/enums/installed-state.enum';
import { EmployeeEquipmentWorkflowInterface } from 'app/equipment/models';
import { EquipmentService } from 'app/equipment/services';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'cz-user-details-equipment',
  templateUrl: './user-details-equipment.component.html',
  styleUrls: ['./user-details-equipment.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UserDetailsEquipmentComponent implements OnInit, OnDestroy {

  @Input() public userId: number;
  @Input() public esppId: number;
  @Input() public readonly: boolean;
  @Input() public headerCheckedState: boolean;
  @Output() public headerChecked: EventEmitter<MatCheckboxChange> = new EventEmitter<MatCheckboxChange>();

  public itemSearchControl: FormControl;

  public employeeWorkFlows$: BehaviorSubject<Readonly<EmployeeEquipmentWorkflowInterface[]>>;
  public recommendedEquipment$: BehaviorSubject<Readonly<EmployeeEquipmentWorkflowInterface[]>>;
  public installedEquipment$: BehaviorSubject<Readonly<EmployeeEquipmentWorkflowInterface[]>>;

  public readonly installedViewState: string = InstalledStateEnum.StateInstalled;
  public readonly recommendedViewState: string = InstalledStateEnum.StateRecommended;

  public loggedInUser: UserInterface;

  private readonly destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(public dialog: MatDialog,
              private _equipmentService: EquipmentService,
              private _authService: AuthService) {
    this.employeeWorkFlows$ = new BehaviorSubject<Readonly<EmployeeEquipmentWorkflowInterface[]>>(undefined);
    this.recommendedEquipment$ = new BehaviorSubject<Readonly<EmployeeEquipmentWorkflowInterface[]>>(undefined);
    this.installedEquipment$ = new BehaviorSubject<Readonly<EmployeeEquipmentWorkflowInterface[]>>(undefined);
  }

  public ngOnInit():void {
    this._authService.getAuthenticatedUser()
    .pipe(
      takeUntil(this.destroy$))
    .subscribe((authenticatedUser: UserInterface) => {
      if (authenticatedUser === undefined) {
        return;
      }

      this.loggedInUser = authenticatedUser;

      this._equipmentService.loadEmployeeEquipmentWorkflows(this.userId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((workFlows: EmployeeEquipmentWorkflowInterface[]) => {
        if(!workFlows) { return; }

        const recommendedEquipment: EmployeeEquipmentWorkflowInterface[] =
          workFlows.filter((workFlow: EmployeeEquipmentWorkflowInterface) => {
            if(workFlow.equipmentItem.currentInstalledState.state === InstalledStateEnum.StateRecommended) {
              return workFlow;
            }
          });

        this.recommendedEquipment$.next(recommendedEquipment);

        const installedEquipment: EmployeeEquipmentWorkflowInterface[] =
          workFlows.filter((workFlow: EmployeeEquipmentWorkflowInterface) => {
            if(workFlow.equipmentItem.currentInstalledState.state === InstalledStateEnum.StateInstalled) {
              return workFlow;
            }
          });

        this.installedEquipment$.next(installedEquipment);

        this.employeeWorkFlows$.next(workFlows);
      });
    });
  }

  public headerCheckboxChecked(event: MatCheckboxChange): void {
    this.headerChecked.emit(event);
  }

  public stopPropagation(event: Event): void {
    event.stopPropagation();
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
